import { FC } from 'react';
import { createPortal } from 'react-dom';

import { DragOverlay, DragOverlayProps } from '@dnd-kit/core';
import { AnimatePresence } from 'framer-motion';

export const PortalDragOverlay: FC<DragOverlayProps> = ({ children, ...rest }) => {
  return createPortal(
    <DragOverlay {...rest}>
      <AnimatePresence>{children}</AnimatePresence>
    </DragOverlay>,
    document.body
  );
};
